import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Users from "../Pages/Admin/Users/index";
import Security from "../Pages/Admin/Security";
import Fuel from "../Pages/Admin/Fuel";
import FuelStations from "../Pages/Admin/FuelStations";
import Vehicles from "../Pages/Admin/Vehicles";
import Companies from "../Pages/Admin/Company/index";
import Settings from "../Pages/Admin/Settings";

const AdminRoutes = () => {
  return (
    <Routes>
      <Route path="/general" element={<Users />} />
      <Route path="/security" element={<Security />} />
      <Route path="/fuel" element={<Fuel />} />
      <Route path="/vehicles/:userId" element={<Vehicles />} />
      <Route path="/stations" element={<FuelStations />} />
      <Route path="/companies" element={<Companies />} />
      <Route path="/settings" element={<Settings />} />

      <Route path="*" element={<Navigate to={"/general"} />} />
    </Routes>
  );
};

export default AdminRoutes;
